import http from '@/utils/services/http'

export default {
  find (lote) {
    return http.get(`/api/lote/${lote}/dados-consulta`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  update (dadosId, data) {
    return http.patch(`/api/lote/dados-consulta/${dadosId}`, JSON.stringify(data))
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/domain/leiloes/services/lote-dados-consulta.js